import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface SectionHeaderItem {
  label: string;
  value: string | null;
}

@Component({
  selector: 'gax-calculation-employee-information-section-header',
  templateUrl:
    './calculation-employee-information-section-header.component.html',
  styleUrls: [
    './calculation-employee-information-section-header.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalculationEmployeeInformationSectionHeaderComponent {
  @Input() items: SectionHeaderItem[] = [];
}
